import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const BankMasterListApi = createSlice({
  name: "BankMasterListApi",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_bank_master: (state, action?: any) => {
      state.isLoading = true;
    },
    success_api_call_bank_master: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
    },
    failure_api_call_bank_master: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    bank_master_isFirst: (state, action) => {
      state.isFirst = false;
    },
  },
});
export default BankMasterListApi.reducer;
export const {
  list_bank_master,
  success_api_call_bank_master,
  failure_api_call_bank_master,
  bank_master_isFirst,
} = BankMasterListApi.actions;
